module.exports = __webpack_public_path__ + "static/media/outlookIcon.38f7e5f3.svg";